import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import {RESET_STORE} from 'constants/ActionTypes'
import Settings from "./Settings";
import Auth from "./Auth";
import Quota from "./Quota";
import Crisis from "./Crisis";
import Buzz from "./Buzz";
import Campaign from "./Campaign";
import RateCard from "./RateCard";
import RateCardValue from "./RateCardValue";
import PeopleLevelInBrand from "./PeopleLevelInBrand";
import PeopleLevelInCampaign from "./PeopleLevelInCampaign";
import Freq from "./Freq";
import Category from "./Category";
import Industry from "./Industry";
import Role from "./Role";
import SampleSize from "./SampleSize";
import AnalysisLevelGuide from "./AnalysisLevelGuide";
import Log from "./Log";

const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  quota: Quota,
  crisis: Crisis,
  buzz: Buzz,
  campaign: Campaign,
  rateCard: RateCard,
  rateCardValue: RateCardValue,
  peopleLevelInBrand: PeopleLevelInBrand,
  peopleLevelInCampaign: PeopleLevelInCampaign,
  freq: Freq,
  category: Category,
  industry: Industry,
  role: Role,
  sampleSize: SampleSize,
  analysisLevelGuide: AnalysisLevelGuide,
  log: Log,
});

export default (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }

  return reducers(state, action);
};

